module.exports = {"pagination":{"GetResourceConfigHistory":{"input_token":"nextToken","limit_key":"limit","output_token":"nextToken","result_key":"configurationItems"}}}


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/config-2014-11-12.paginators.json
// module id = 328
// module chunks = 1